module.exports = __webpack_public_path__ + "img/cms_asset_publish.2e02ede8.jpg";